// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Hs7l"};